import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Import, ImportStatus } from "types/Import";

type Props = {
  item: Import;
};

function ImportTrainingContentCard({ item }: Props) {
  const { t } = useTranslation();

  const { parsedContent, status, error } = item;

  const nbSteps = useMemo(() => {
    if (parsedContent?.data && parsedContent?.data[0]) {
      return parsedContent?.data[0]?.steps?.length;
    }
    return 0;
  }, [parsedContent]);

  return parsedContent && nbSteps > 0 && status !== ImportStatus.ERROR ? (
    <div className="flex flex-col">
      {parsedContent?.data[0]?.name && (
        <span>{`${t("import.trainingName")} ${
          parsedContent?.data[0]?.name
        }`}</span>
      )}
      <span>{`${t("import.nbTotalSteps")} ${nbSteps}`}</span>
    </div>
  ) : status === ImportStatus.ERROR && error ? (
    <span>
      <strong>{t("import.errorDetail")}</strong>
      {t(`import.errors.${item.error?.key}`)}
    </span>
  ) : (
    <span>
      <strong>{t("import.errorUnknown")}</strong>
    </span>
  );
}

export default ImportTrainingContentCard;
